import { Table, Tag } from '@exxonmobil/react-unity';
import { isString } from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { CellProps } from '../types/CellValueGroup';

export interface DomainTableCellProps {
  name: string;
  process?: string;
  totalConsumers: number;
  totalConsumptionVolume: string;
}

export const CommonTableCell = ({ values }: Partial<CellProps>) => <Table.Body.Cell>{values}</Table.Body.Cell>;

export const DomainTableCell = ({ name, process, totalConsumers, totalConsumptionVolume }: DomainTableCellProps) => (
  <Table.Body.Cell dropdown colSpan={11}>
    <FlexColumnDiv>
      <FlexRowDiv>
        {name}
        <StyledTag key="1" className="em-c-tags--light">
          {process}
        </StyledTag>
      </FlexRowDiv>
      <StyledSpan>
        {totalConsumers} Unique consumer(s) | {totalConsumptionVolume} Volume
      </StyledSpan>
    </FlexColumnDiv>
  </Table.Body.Cell>
);

export const SourceTableCell = ({ values }: Partial<CellProps>) => {
  const sources = values as string[];
  return (
    <Table.Body.Cell>
      <Tag.Group>
        {sources.map((source) => (
          <Tag key={source} className="em-c-tags--light">
            {source}
          </Tag>
        ))}
      </Tag.Group>
    </Table.Body.Cell>
  );
};

export const ConsumerTableCell = ({ values, onClick, additionalValues, additionalFunction }: any) => {
  const toRender = values as string[] | number[];
  const showTotal = additionalValues[0];
  const multipleConsumer = additionalValues[1];

  const totalRow = () => {
    if (Number.isInteger(values[0])) {
      return <b>{values.reduce((partialSum: number, a: number) => partialSum + a, 0)}</b>;
    }
    if (isString(values[0])) {
      return <b>total</b>;
    }
    return null;
  };

  return (
    <Table.Body.Cell onClick={onClick}>
      <StyledConsumerCell>
        {toRender.map((value, index) => {
          if (!showTotal && toRender.length === 1 && isString(value) && index === 0 && multipleConsumer) {
            return (
              <SeeMoreContainer>
                <p style={{ lineHeight: '1' }}>{value}</p>
                <StyledSeeMore onClick={additionalFunction}>see more</StyledSeeMore>
              </SeeMoreContainer>
            );
          }
          return <p style={{ lineHeight: '1' }}>{value}</p>;
        })}
      </StyledConsumerCell>
      {/* if showTotal is true */}
      {showTotal && <StyledConsumerCell>{totalRow()}</StyledConsumerCell>}
    </Table.Body.Cell>
  );
};

const FlexColumnDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

const FlexRowDiv = styled.div`
  display: flex;
  flex-direction: row;
`;

const StyledTag = styled(Tag)`
  margin-bottom: 0;
  margin-left: 5px;
`;

const StyledSpan = styled.span`
  font-size: 0.75rem;
  margin-top: 8px;
  color: grey;
`;

const StyledConsumerCell = styled.p`
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  margin-right: 8px;
  margin-bottom: 0;
`;

const SeeMoreContainer = styled.div`
  display: flex;
  align-item: center;
`;

const StyledSeeMore = styled.a`
  display: 'inline';
  line-height: 1;
  cursor: pointer;
  margin-left: 0.5rem;
`;
